export enum RouteEnum {
  ATTEMPT = '/attempt/:attemptId',
  ATTEMPT_DETAILS = '/attempts/:attemptId',
  ATTEMPT_EXAM = '/attempts/:attemptId/exam',
  ATTEMPTS = '/attempts',
  DASHBOARD = '/dashboard',
  DEV_PATTERNS = '/dev/patterns',
  DICTIONARIES = '/dictionaries',
  PATHS = '/paths',
  PROCESSES = '/processes',
  QUESTION_BANK = '/question-bank',
  QUESTION_CREATE = '/question-bank/new',
  QUESTION_EDIT = '/question-bank/:questionId',
  QUESTION_FOCUS = '/question-bank/focus',
  QUESTION_HISTORY = '/question-bank/:questionId/history',
  QUESTION_RANKING = '/question-statistics',
  QUESTION_STATISTICS = '/question-bank/:questionId/statistics',
  ROOT = '/',
  SETTINGS = '/settings',
  SURVEY_CREATE = '/surveys/new',
  SURVEY_EDIT = '/surveys/:surveyId',
  SURVEY_HISTORY = '/surveys/:surveyId/history',
  SURVEY_RESPONSE = '/survey/:responseId',
  SURVEY_RESPONSE_DETAILS = '/surveys/:surveyId/responses/:responseId',
  SURVEY_RESPONSES = '/surveys/:surveyId/responses',
  SURVEYS = '/surveys',
  TEST_CREATE = '/tests/new',
  TEST_EDIT = '/tests/:testId',
  TEST_HISTORY = '/tests/:testId/history',
  TESTS = '/tests',
}
